import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, ToastController, AlertController, LoadingController, Events, NavController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

import { ServiceSidemenuProvider } from '../providers/service-sidemenu/service-sidemenu';
import { ServiceGvariableProvider } from '../providers/service-gvariable/service-gvariable';
import { Storage } from '@ionic/storage';
import { Network } from '@ionic-native/network';
import { NetworkProvider } from '../providers/service-network/network';
import crc32 from 'crc/crc32';

//page
import { A01LoginPage } from '../pages/a01-login/a01-login';
import { B01SalesPage } from '../pages/b01-sales/b01-sales';
import { B02RefundPage } from '../pages/b02-refund/b02-refund';
import { B03ReportPage } from '../pages/b03-report/b03-report';
import { B03D02ReportFullPage } from '../pages/b03-d02-report-full/b03-d02-report-full';
import { B04LaybyPage } from '../pages/b04-layby/b04-layby';
import { B05ProfilePage } from '../pages/b05-profile/b05-profile';
import { B06SettingPage } from '../pages/b06-setting/b06-setting';
import { B01D02SalesPaymentPage } from '../pages/b01-d02-sales-payment/b01-d02-sales-payment';
import { B07LogoutPage } from '../pages/b07-logout/b07-logout';
import { ServiceApiProvider } from '../providers/service-api/service-api';
import { B09InventoryPage } from '../pages/b09-inventory/b09-inventory';

interface cardInfo{
};
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = A01LoginPage;
  loading: any;
  Status: any;
  pages=[];
  localData= [];
  accessPage: any = {title:'', component: '', class:'', icon:''};
  userAccessId: any = null;
  accessResult: any;
  cardArr: cardInfo[] = [];
  tempData=[];
  arraydata=[];
  arraydata2=[];
  userRunNo2: number;
  SO_NO: any;
  pageComponent: any = '';

  paymentData = { AMOUNT_TENDER:0, AMOUNT_CHANGE:'', CORP_CARD_NO:'', AUTH_NO:'',
                  DATETIME:'', PAYMENT_TYPE_ID:'',
                }
  salesData =   { SOL_DESC:'', QTY:0, UNIT_PRICE:'', DISC_PERC: '', TAX_PERC:'', TOTAL_TAX:'',
                  SOL_TOTAL:'', GRAND_SOL_TOTAL:0, INVENTORY_ID:'',
                }
  fleetData = { RunNo: '', DateTime: '',
                  Payment:[this.paymentData],
                  Sales:[this.salesData],
                } 
  fleetData1: any;
  temp_SO_NO: string;
  SO_USER_ID: string;
  SO_SO_NO: string;
  userId: string;

  constructor(public platform: Platform, public statusBar: StatusBar, 
              public splashScreen: SplashScreen, public sidemenu:ServiceSidemenuProvider,
              private toastCtrl: ToastController, private screenOrientation: ScreenOrientation,
              public alertCtrl : AlertController, public loadingCtrl: LoadingController,
              public servicegvariable:ServiceGvariableProvider, public serviceapi: ServiceApiProvider,
              public storage: Storage, public events: Events, private network: Network, public networkProvider: NetworkProvider,
              ) {

      //temporary bar due to web not support, unlock when install at tablet
/*     this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE); */ 
    this.initializeApp();


    //initialize internet connection flag
    let tbl = ["INVENTORY"];
    let column = ["INVENTORY_ID"];
    let value = ["1"];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
      this.servicegvariable.InternetConnection = "Online";

    }, (err) => {
      this.servicegvariable.InternetConnection = "Offline";
    });

    
    setInterval(() => {
      console.log("10min time");
      //load dummy to check internet connection 
      let tbl = ["INVENTORY"];
      let column = ["INVENTORY_ID"];
      let value = ["1"];

      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
//        if (this.servicegvariable.InternetConnection == 'Offline'){
          this.servicegvariable.InternetConnection = 'Online';

          //this.tempData = '';
          this.storage.get('localData2').then((data) => {
            this.tempData = data;
            
            console.log(this.tempData);
            this.storage.remove('localData2');                  //clear localdata2 while uploading to receive new sales data 210320
            
            if (data && data.length > 0) {
              this.syncServer();
            }
            else{
              if (this.pageComponent != '') {
                                                                //s31 
//                      this.nav.setRoot(this.pageComponent);           //reload current side menu when offline to online
              
              
              /* let page = this.nav.getActive().component;
              this.nav.setRoot(page); */
              }
            }
          });


/*           let confirm = this.alertCtrl.create({
            title: 'Online',
            message: 'Device is online now.',
            buttons: [
              {
                text: 'Confirm',
                handler: () => {
                  console.log('Agree clicked');
                  this.tempData = '';
                  this.storage.get('localData').then((data) => {
                    this.tempData = data;
                    
                    console.log(this.tempData);
                    
                    if (data && data.length > 0) {
//                      this.showLoader();
                      this.syncServer(0);
                    }
                    else{
                      if (this.pageComponent != '') {
                                                                        //s31 
//                      this.nav.setRoot(this.pageComponent);           //reload current side menu when offline to online
                      
                      
                      /* let page = this.nav.getActive().component;
                      this.nav.setRoot(page); */
/*                      }
                    }
                  });
                }
              }
            ],
            enableBackdropDismiss : false
          });
          confirm.present(); */
//        } 
      }, (err) => {
        console.log("online offline")
        
//        if (this.servicegvariable.InternetConnection == 'Online'){
          this.servicegvariable.InternetConnection = 'Offline';
          /* let confirm = this.alertCtrl.create({
            title: 'Offline',
            message: 'No internet connection. Transaction will store at local device until internet connection again.',
            buttons: [
              {
                text: 'Confirm',
                handler: () => {
                console.log('Agree clicked');
                }
              }
            ]
          });
          confirm.present(); */
//        }  
      });
    }, 600000);       //every 10min
//    }, 30000);       //every 0.5min


    if(sessionStorage.getItem("useraccessid") != null)
    {
      let useraccess = sessionStorage.getItem("useraccessid");
      let i=0;
      let user = useraccess.split(',');

      this.userAccessId = user;
     
      this.showmenu();

      events.subscribe('user:created', (username, useraccess, time) => {
        // user and time are the same arguments passed in `events.publish(user, time)`
        console.log(useraccess);
        
        this.userAccessId = useraccess;

        this.showmenu();
        this.nav.setRoot(B01SalesPage);
  
      });
      
    }
    else
    {
      // events in case of different user authority
      events.subscribe('user:created', (username, useraccess, time) => {
        // user and time are the same arguments passed in `events.publish(user, time)`
        console.log(useraccess);
        
        this.userAccessId = useraccess;

        this.showmenu();
        this.nav.setRoot(B01SalesPage);
  
      });
    } 
    
    //Change to check internet every 10min
     window.addEventListener('offline', () => {
      if (this.servicegvariable.InternetConnection == 'Online'){
        this.servicegvariable.InternetConnection = 'Offline';

        //Change to upload Fleet card SO every 10min
        /* let confirm = this.alertCtrl.create({
          title: 'Offline',
          message: 'No internet connection. Transaction will store at local device until internet connection again.',
          buttons: [
            {
              text: 'Confirm',
              handler: () => {
              console.log('Agree clicked');
                
              }
            }
          ]
        });
        confirm.present(); */
      }
    });

    window.addEventListener('online', () => {
      if (this.servicegvariable.InternetConnection == 'Offline'){
        this.servicegvariable.InternetConnection = 'Online';

        //Change to upload Fleet card SO every 10min
        /* let confirm = this.alertCtrl.create({
          title: 'Online',
          message: 'Device is online now.',
          buttons: [
            {
              text: 'Confirm',
              handler: () => {
                console.log('Agree clicked');
                this.tempData = '';
                this.storage.get('localData').then((data) => {
                  this.tempData = data;
                  
                  console.log(this.tempData);
                  
                  if (data && data.length > 0) {
//                    this.showLoader();
                    this.syncServer(0);
                  }
                  else{
                    if (this.pageComponent != '') {
                                                                        //s31
//                      this.nav.setRoot(this.pageComponent);           //reload current side menu when offline to online
                    
                      /* let page = this.nav.getActive().component;
                    this.nav.setRoot(page); */
/*                    }
                  }
                });
              }
            }
          ],
          enableBackdropDismiss : false                               //force user to click OK
        });
        confirm.present(); */
      }
    }); 


  }


  syncServer(){
    let userId = sessionStorage.getItem('userid');
     /*this.storage.get('localData2').then((data) => {
      this.localData = data;
    }); 
    console.log(this.localData)*/

    let value = this.SUBMIT_JSON(userId, this.tempData);
    this.userId = userId;
    console.log(value);

    if (this.servicegvariable.InternetConnection == 'Online'){

      this.serviceapi.possalesdata(value).then((result) => {
        this.Status = result["Message"];
        console.log(this.Status);
        if (this.Status == "1"){
          // [YOW:22/07/2020:CR/MPOS/20-03]:Comment (Do not update here. Only update when login)
          /*
          //let Records = result["Records"];
          this.temp_SO_NO = result["USER_RUNNO2"];
          this.SO_USER_ID = this.pad_with_zeroes(this.userId, 4);
          this.SO_SO_NO = this.pad_with_zeroes(this.temp_SO_NO, 10);        //add zero infront to make it 10 digit
          this.SO_NO = 'CS' + this.SO_USER_ID + 'A' + this.SO_SO_NO;        //CS for fleet card sales
          console.log(this.SO_NO);
          //take last SO NO when upload 
          let val3 = JSON.stringify(this.SO_NO);                            //save last SO_NO
          this.storage.set('lastSO_NO2', val3); 

          this.userRunNo2 = 0;
          let val4 = JSON.stringify(this.userRunNo2);
          this.storage.set('runningNoData2', val4);
          */
          /* this.storage.remove('localData2');                             //success update, delete closing record */
        }
        else{
          this.storage.get('localData2').then((data) => {
            let val2 = "";
            let val3 = "";
            let count = 0;
            let newData = data;
            this.arraydata = this.tempData;
            let array = [];
            console.log(newData)
            console.log(this.arraydata,this.arraydata.length)
            if (newData && newData.length > 0) {
              for(count = 0;count <this.arraydata.length;count++)
              {
                val2 = this.arraydata[count];
                array.push(val2);
              }
              for(count = 0;count <newData.length;count++)
              {
                val3 = newData[count];
                array.push(val3);
              }
              console.log(array);
              this.storage.set('localData2', array);
            } 
            else{
              this.storage.set('localData2', this.arraydata);
            }
          });

        }
      }, (err) => {
//        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      });
    }
    else {
//      this.errorMessage = "Internet Offline. Please check internet connection.";
    }
  }

  SUBMIT_JSON(USERID, DATA)
  {
    let COMPILE_DATA = {
      Param:"",
      UserID: "",
      Total:0,
      CRC:0,
      Data:[]
    }

    COMPILE_DATA.Param = "4";                         //Param 1
    COMPILE_DATA.UserID = USERID;
    COMPILE_DATA.Total =  DATA.length;
    COMPILE_DATA.Data = DATA;
    let val = JSON.stringify(DATA);
    console.log(val);
    COMPILE_DATA.CRC = crc32(val);

    return COMPILE_DATA;
  }

  showmenu()
  {
    if((this.userAccessId.some(x => x === "11")) == true)            //check access id and filter side menu page
    {
      this.accessPage = { title: 'Sales', component: B01SalesPage, class:'sidemenu-active', icon:'cart' },
      this.pages.push(this.accessPage);
    } 
    if((this.userAccessId.some(x => x === "12")) == true)
    {
      this.accessPage = { title: 'Lay-by', component: B04LaybyPage, class:'sidemenu-non-active', icon:'hand' },
      this.pages.push(this.accessPage);
    } 
    if((this.userAccessId.some(x => x === "13")) == true)
    {
      this.accessPage = { title: 'Refund', component: B02RefundPage, class:'sidemenu-non-active', icon:'undo' },
      this.pages.push(this.accessPage);
    } 
    if((this.userAccessId.some(x => x === "17")) == true)
    {
      this.accessPage = { title: 'Inventory', component: B09InventoryPage, class:'sidemenu-non-active', icon:'cube' },
      this.pages.push(this.accessPage);
    } 
    if((this.userAccessId.some(x => x === "14")) == true)
    {
      this.accessPage = { title: 'Report', component: B03ReportPage, class:'sidemenu-non-active', icon:'document' },
      this.pages.push(this.accessPage);
    } 
    if((this.userAccessId.some(x => x === "15")) == true)
    {
      this.accessPage = { title: 'Setting', component: B06SettingPage, class:'sidemenu-non-active', icon:'settings' },
      this.pages.push(this.accessPage);
    }

    this.accessPage = { title: 'Logout', component: B07LogoutPage, class:'sidemenu-non-active', icon:'log-out' },
    this.pages.push(this.accessPage);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      this.networkProvider.initializeNetworkEvents();

      
        // Offline event
     this.events.subscribe('network:offline', () => {
        if (this.servicegvariable.InternetConnection == 'Online'){
          this.servicegvariable.InternetConnection = 'Offline';

          //Change to upload Fleet card SO every 10min
          /* let confirm = this.alertCtrl.create({
            title: 'Offline',
            message: 'No internet connection. Transaction will store at local device until internet connection again.',
            buttons: [
              {
                text: 'Confirm',
                handler: () => {
                console.log('Agree clicked');
                  
                }
              }
            ]
          });
          confirm.present(); */
        }  
      });

      // Online event
      this.events.subscribe('network:online', () => {
        if (this.servicegvariable.InternetConnection == 'Offline'){
          this.servicegvariable.InternetConnection = 'Online';

          //Change to upload Fleet card SO every 10min
          /* let confirm = this.alertCtrl.create({
            title: 'Online',
            message: 'Device is online now.',
            buttons: [
              {
                text: 'Confirm',
                handler: () => {
                  console.log('Agree clicked');
                  this.tempData = '';
                  this.storage.get('localData').then((data) => {
                    this.tempData = data;
                    
                    console.log(this.tempData);
                    
                    if (data && data.length > 0) {

                      //load dummy to check internet connection 
                      let tbl = ["INVENTORY"];
                      let column = ["INVENTORY_ID"];
                      let value = ["1"];

                      let tblkey = ["No"];
                      let fktbl = ["No"];
                      let fkkey = ["No"];

                      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

                      let mydata = Object.assign(jsonitem);
                      let json_data = this.serviceapi.json_readdata(mydata,"1");
                      this.showonlineLoader();
                      this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
                        this.loading.dismiss();
//                        this.showLoader();
                        this.syncServer(0);
                      }, (err) => {
                        console.log("online offline")
                        this.loading.dismiss();
                        this.servicegvariable.InternetConnection = 'Offline';
                      });
                    }
                    else{
                      if (this.pageComponent != '') {
                                                                          //s31
//                        this.nav.setRoot(this.pageComponent);           //reload current side menu when offline to online
                      }
                    }
                  });
                }
              }
            ],
            enableBackdropDismiss : false
          });
          confirm.present(); */
        }      
      });
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page.title == 'Logout'){                        //pop up window for logout
      let confirm = this.alertCtrl.create({
        title: 'Confirmation',
        message: 'Are you sure you want to logout?',
        buttons: [
          {
            text: 'No',
            handler: () => {
            console.log('Disagree clicked');
            }
          }, 
          {
            text: 'Yes',
            handler: () => {
            console.log('Agree clicked');
              
            this.showLoaderLogout();

            sessionStorage.clear();                       //clear temporary user data
            this.pages=[];                                //clear side menu page
            this.nav.setRoot(A01LoginPage);

            setTimeout(()=>{
              this.loading.dismiss();  
            },500);
          

            }
          }
        ]
      });
      confirm.present();
      
    }
    else {
      this.pageComponent = page.component;

      this.nav.setRoot(page.component);
      page.class='sidemenu-active';

      for (let p of this.pages) {
      
        if(p.title==page.title)
        {
          p.class='sidemenu-active';
        }
        else
        {
          p.class='sidemenu-non-active';
        }
      }
    }
  }

  showLoaderLogout(){
    this.loading = this.loadingCtrl.create({
        content: 'Logout...',
        duration: 5000,
    });

    this.loading.present();
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });

    this.loading.present();
  }

  showonlineLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Check network status...',
        duration: 5000,
    });
    this.loading.present();
  }

  pad_with_zeroes(number, length) {                                   //routine to add 0 infront number

    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts